import BrandLockup from "./BrandLockup";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 pt-16 pb-10 bg-ink" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 flex flex-col md:flex-row md:items-end justify-between gap-8">
        <div>
          <BrandLockup size="lg" />
          <p className="mt-4 font-display italic text-orange text-lg">Wellness essentials on the go</p>
          <p className="mt-4 text-bone/50 text-sm max-w-xs leading-relaxed">
            Fully managed, cashless access to everyday essentials — designed for airports, campuses, student living and high-traffic locations.
          </p>
        </div>
        <div className="text-left md:text-right space-y-2">
          <p className="eyebrow">Pilot enquiries</p>
          <a href="mailto:support@minisrus.com.au" className="block text-bone hover:text-gold link-underline text-sm" data-testid="footer-email">
            support@minisrus.com.au
          </a>
          <a href="/privacy/" className="block pt-1 text-bone/60 hover:text-orange text-xs" data-testid="footer-privacy">
            Privacy policy
          </a>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-6 md:px-10 mt-10">
        <div className="h-px w-full bg-white/5" />
        <div className="mt-6 flex flex-col md:flex-row md:items-center justify-between gap-3 text-bone/40 text-xs">
          <p>© {new Date().getFullYear()} MinisRus. All rights reserved.</p>
          <p className="tracking-widest uppercase">Pharmacist-founded · Wellness on the go · 24/7</p>
        </div>
      </div>
    </footer>
  );
}
